/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { NavigationGuard } from '@core/guards/navigation.guard';
import { RoutePaths } from '@global/routePaths';

export const ModifyPolicyActionsRoutes: Routes = [
  {
    path: RoutePaths.MODIFY_POLICY.ACTIONS.route,
    loadChildren: () =>
      import('@pages/modify-policy-actions/modify-policy-actions.module').then(m => m.ModifyPolicyActionsPageModule),
    canActivate: [NavigationGuard],
  },
];
